
import React from "react";
import { Navigate, useLocation } from 'react-router-dom'
import { useSelector } from "react-redux";


// get user data from state
const authData = (state) => state.auth;

function PrivateRoute({ children }) {
  const data = useSelector(authData);
  let { loggedIn } = data;;
  let location = useLocation();
  
  if (!loggedIn) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
}

export default PrivateRoute